import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, BarChart3 } from 'lucide-react';
const features = [{
  icon: Zap,
  title: 'Seamless Integration',
  description: 'A single click synchronizes your WooCommerce store with KRA eTims. No friction, just fluid operation.'
}, {
  icon: ShieldCheck,
  title: 'Real-Time Compliance',
  description: 'Every transaction is reported instantly and accurately. Rest assured knowing your business stands on solid ground.'
}, {
  icon: BarChart3,
  title: 'Effortless Management',
  description: 'An intuitive dashboard that transforms complex tax data into clear, actionable insights for the modern executive.'
}];
export function Features() {
  return <section className="py-32 bg-sovereign-navy text-white" data-id="element-48">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-49">
        <div className="text-center mb-24" data-id="element-50">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-4xl md:text-5xl font-serif mb-6" data-id="element-51">
            Refined Capability
          </motion.h2>
          <motion.div initial={{
          width: 0
        }} whileInView={{
          width: '60px'
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="h-[2px] bg-sovereign-gold mx-auto" data-id="element-52" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-53">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="group relative p-10 bg-sovereign-navy-light border border-sovereign-gold/20 hover:border-sovereign-gold/50 transition-colors duration-500 shadow-sm hover:shadow-xl" data-id="element-54">
              <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-sovereign-gold/50 to-transparent scale-x-0 group-hover:scale-x-100 transition-transform duration-700" data-id="element-55" />

              <feature.icon className="w-10 h-10 text-sovereign-gold mb-8 stroke-[1.5]" data-id="element-56" />

              <h3 className="text-2xl font-serif mb-4 text-white" data-id="element-57">
                {feature.title}
              </h3>

              <p className="text-gray-400 leading-relaxed font-light" data-id="element-58">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}